import { memo, useState } from 'react';
import { Select, Tag } from 'antd';
import { useBaseContext, useSearchContext } from '../Context';
import { useTranslate } from '@tolgee/react';
import { getStoreCount, StoreScopes } from 'components/StoreScopes';
import { css } from '@emotion/css';
import { useScopedStores } from '../hooks/useScopedStores';

export const StoreSelect = memo(() => {
  const { platformStoreScope, setParams } = useSearchContext();
  const { t } = useTranslate();
  const [visible, setVisible] = useState(false);
  const { defaultStores, defaultStoreScopes } = useBaseContext();
  const storeDataSource = useScopedStores(defaultStoreScopes);
  return (
    <Select
      mode="multiple"
      showSearch={false}
      placeholder={t('remind.选择店铺')}
      value={platformStoreScope.length ? ['placeholder'] : []}
      className="basis-[160px]"
      allowClear
      onClear={() => {
        setParams({
          platformStoreScope: [],
        });
      }}
      tagRender={() => (
        <Tag>
          {t('department.已选x店铺', {
            x: getStoreCount(platformStoreScope || []),
          })}
        </Tag>
      )}
      open={visible}
      onDropdownVisibleChange={setVisible}
      placement="bottomLeft"
      dropdownRender={(_menu) =>
        visible ? (
          <StoreScopes
            allowEmpty
            supportWa={false}
            className={css`
              max-height: 95vh;
              overflow-y: auto;
            `}
            value={platformStoreScope}
            onCancel={() => setVisible(false)}
            showFooterTips={false}
            onChange={(storeScopes) => {
              setParams({
                platformStoreScope: storeScopes,
              });
            }}
            storeDataSource={
              defaultStores?.length
                ? defaultStores
                : storeDataSource?.length
                ? storeDataSource
                : undefined
            }
          />
        ) : (
          <></>
        )
      }
      dropdownClassName={dropdownClassName}
    />
  );
});

const dropdownClassName = css`
  width: 950px !important;
  overflow-y: auto;
  padding-top: 0;
  padding-bottom: 0;
  color: rgba(0, 0, 0, 0.85);
  [data-color-mode='dark'] & {
    color: var(--fett-text-primary);
  }
`;

StoreSelect.displayName = 'ItemSelectV5StoreSelect';
